// extracted by mini-css-extract-plugin
export default {"dialogPaper":"PackageCreationDialog_dialogPaper__OpLcw"};